/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="63.58"
        height="95.35"
        viewBox="0 0 63.58 95.35"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M62.34 0a1.25 1.25 0 0 1 1.24 1.12v81.2a1.27 1.27 0 0 1-1.13 1.25h-4.62a1.25 1.25 0 0 1-.13-2.49h3.37V2.5H22.84L2.5 22.84v58.23h25.39a1.26 1.26 0 0 1 1.24 1.13v.12A1.27 1.27 0 0 1 28 83.57H1.25A1.24 1.24 0 0 1 .01 82.5V22.32a1.29 1.29 0 0 1 .27-.78l.1-.1L21.44.37a1.24 1.24 0 0 1 .74-.36h40.16Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M22.32 0a1.24 1.24 0 0 1 1.24 1.12v21.2a1.26 1.26 0 0 1-1.06 1.25H1.25a1.25 1.25 0 0 1-.13-2.49h19.95V1.25A1.24 1.24 0 0 1 22.19.01Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M34.63 74.08a1.016 1.016 0 0 1 2 .36v.12l-4 16.1 3.71-.78a1.05 1.05 0 0 1 .72.12l.1.07 3.25 2.54 4-16.47a1 1 0 0 1 1.09-.76h.12a1 1 0 0 1 .78 1.12v.11l-4.39 18a1 1 0 0 1-1.49.61l-.1-.06-4.1-3.2-4.81 1a1 1 0 0 1-1.2-1.11v-.11Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M49.9 73.35a1 1 0 0 1 1.18.62v.11l4.33 17.65a1 1 0 0 1-1.07 1.24h-.11l-4.81-1-4.1 3.2a1 1 0 0 1-1.55-.44v-.11L41.9 87a1 1 0 0 1 1.91-.59v.11l1.49 6.09 3.24-2.53a1 1 0 0 1 .7-.21h.12l3.72.78-4-16.11a1 1 0 0 1 .62-1.18Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M40.81 50.93a1.74 1.74 0 0 1-1.92.44 2.58 2.58 0 0 0-3.71 1.78 1.74 1.74 0 0 1-1.53 1.23 2.58 2.58 0 0 0-2.57 3.22 1.73 1.73 0 0 1-.86 1.77 2.59 2.59 0 0 0-.91 4 1.75 1.75 0 0 1 0 2 2.58 2.58 0 0 0 .92 4 1.74 1.74 0 0 1 .85 1.77 2.58 2.58 0 0 0 2.56 3.22 1.75 1.75 0 0 1 1.54 1.23 2.58 2.58 0 0 0 3.72 1.78 1.75 1.75 0 0 1 1.91.44 2.6 2.6 0 0 0 4.12 0 1.73 1.73 0 0 1 1.92-.44 2.58 2.58 0 0 0 3.71-1.79 1.75 1.75 0 0 1 1.54-1.23 2.59 2.59 0 0 0 2.57-3.22 1.74 1.74 0 0 1 .85-1.77 2.59 2.59 0 0 0 .92-4 1.72 1.72 0 0 1 0-2 2.59 2.59 0 0 0-.92-4 1.74 1.74 0 0 1-.85-1.77 2.58 2.58 0 0 0-2.57-3.22 1.75 1.75 0 0 1-1.54-1.23 2.58 2.58 0 0 0-3.71-1.78 1.74 1.74 0 0 1-1.92-.44 2.59 2.59 0 0 0-4.12.01Zm2.57 1.26a3.74 3.74 0 0 0 4.12 1.06l.18-.07a.59.59 0 0 1 .89.33v.1a3.71 3.71 0 0 0 3.27 2.76h.19a.58.58 0 0 1 .65.68v.11a3.77 3.77 0 0 0 1.82 3.92l.17.09a.59.59 0 0 1 .22 1 3.7 3.7 0 0 0 0 4.44.58.58 0 0 1-.14.93h-.09a3.75 3.75 0 0 0-2 3.82v.18a.59.59 0 0 1-.63.79 3.73 3.73 0 0 0-3.46 2.77.59.59 0 0 1-.82.48h-.1a3.72 3.72 0 0 0-4.32 1 .6.6 0 0 1-1 0 3.73 3.73 0 0 0-4.11-1.08l-.18.08a.58.58 0 0 1-.88-.34v-.1a3.75 3.75 0 0 0-3.47-2.77.58.58 0 0 1-.65-.68v-.11a3.74 3.74 0 0 0-1.76-3.91l-.16-.09a.59.59 0 0 1-.23-1 3.72 3.72 0 0 0 0-4.44.58.58 0 0 1 .13-.93h.09a3.72 3.72 0 0 0 1.93-4 .59.59 0 0 1 .53-.79h.1a3.74 3.74 0 0 0 3.42-2.58v-.19a.59.59 0 0 1 .81-.48h.1a3.74 3.74 0 0 0 4.33-1 .59.59 0 0 1 1.05.02Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M43 58.24a6.32 6.32 0 1 0 6.32 6.32A6.31 6.31 0 0 0 43 58.24"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M43 57.5a7.07 7.07 0 1 0 7.07 7.07A7.06 7.06 0 0 0 43 57.5Zm0 1.5a5.57 5.57 0 1 1-5.56 5.57A5.57 5.57 0 0 1 43 58.99Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M53 16.38a1.502 1.502 0 0 1 .15 3H22.32a1.502 1.502 0 0 1-.14-3H53ZM53 28.57a1.25 1.25 0 0 1 .13 2.49H10.58a1.252 1.252 0 0 1-.13-2.5H53ZM53 40.55a1.25 1.25 0 0 1 .13 2.49H10.58a1.252 1.252 0 0 1-.13-2.5H53ZM24.43 52.5a1.25 1.25 0 0 1 .13 2.49h-14a1.25 1.25 0 0 1-.06-2.49h14ZM24.43 64.5a1.25 1.25 0 0 1 .13 2.49h-14a1.25 1.25 0 0 1-.06-2.49h14Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'CertificateWithAwardRibbonIcon';

export default Icon;
